import React from "react";
import { Link } from "react-router-dom";
import BlogHeader from "./BlogHeader";
import BlogFooter from "./BlogFooter";
import ChecklistDownload from "./ChecklistDownload";
import "./Blog.css";
import "./BlogPostSafetyManager.css";
import "./BlogPostForeman.css";

function BlogPostRainySeason() {
  const hazards = [
    {
      num: "1",
      title: "침수·익사",
      body: "집중호우로 작업장이 잠기거나 근로자가 물에 빠질 위험이 커집니다. 배수로·집수정·양수기를 점검하고, 저지대 자재·장비·전기설비를 옮기거나 고정합니다. 하천·관로·지하공사는 상류 호우상황과 수위 변화를 모니터링하고, 침수 우려 시 작업을 중지하고 대피합니다.",
    },
    {
      num: "2",
      title: "굴착면 및 흙막이 지보공 무너짐",
      body: "빗물이 스며든 지반은 약해져 무너지기 쉽습니다. 흙막이·버팀보 설치상태와 변형을 점검하고, 굴착면 상부의 균열·용수·유실을 확인하며, 배수로를 정비하고 굴착면 상단 적재를 금지합니다.",
    },
    {
      num: "3",
      title: "감전",
      body: "습도와 땀으로 감전 위험이 커집니다. 누전차단기 작동을 확인하고, 전선 피복·접속부 손상과 물고임 구간을 점검하며, 침수된 전기기계·기구는 사용을 금지합니다.",
    },
    {
      num: "4",
      title: "떨어짐",
      body: "비에 젖은 발판·강재는 미끄럽습니다. 비가 오면 철골 조립·해체 작업은 중지하고 일정을 조정합니다. 특히 풍속 10m/s 이상, 강우량 1mm/h 이상, 강설량 1cm/h 이상이면 철골작업 중지 기준에 해당합니다. 작업발판·안전난간·개구부 덮개·안전대 부착설비를 작업 전 점검합니다.",
    },
    {
      num: "5",
      title: "태풍·강풍으로 인한 무너짐",
      body: "강풍에 비계·거푸집동바리·가설울타리·타워크레인이 넘어질 수 있습니다. 강풍 예보 시 타워크레인은 제조사 설명서·설치기준에 따라 선회 브레이크 해제, 벽체 지지 고정상태 점검, 텔레스코픽 케이지 최하단 하강, 줄걸이 용구·인양물 제거, 후크 감아올림, 전원 차단 등의 조치를 합니다. 가설구조물 결속·고정과 날릴 수 있는 자재 결박도 점검합니다.",
    },
    {
      num: "6",
      title: "온열질환",
      body: "장마가 끝나갈 무렵부터 고온다습한 환경으로 열사병·열탈진 위험이 커집니다. 작업장 체감온도를 확인하고 물·냉방장치·휴식·보냉장구·119 신고 원칙을 적용합니다. 체감온도 31℃ 이상이면 적절한 휴식을, 33℃ 이상이면 2시간 이내 20분 이상 휴식을 기준으로 관리합니다.",
    },
    {
      num: "7",
      title: "낙뢰",
      body: "낙뢰 예보·발생 시 옥외작업, 비계 위 작업, 크레인 인양작업, 금속류 자재 운반작업을 중지하고 근로자를 건물 내부 등 안전한 장소로 대피시킵니다.",
    },
    {
      num: "8",
      title: "중독·질식",
      body: "양수기 배기가스(일산화탄소), 맨홀·배수시설 등 밀폐공간 유해가스로 중독·질식이 발생합니다. 양수기는 밀폐공간 밖에 두고, 작업 전·중 산소·유해가스 농도를 수시로 측정하며, 환기·감시인 배치·호흡용 보호구를 갖춥니다.",
    },
    {
      num: "9",
      title: "산불 이후 산사태 (해당 현장만)",
      body: "산불 피해지·산지·절개지 인근 현장은 적은 비에도 토사유출·산사태가 날 수 있습니다. 지면 균열, 흙탕물 유출, 나무 기울어짐, 지반 진동 등 전조증상을 확인하고, 위험 징후가 있으면 즉시 작업을 중지하고 대피합니다.",
    },
  ];

  const stopRules = [
    ["기상상태 불안정으로 근로자 위험 우려", "사업주는 작업중지 및 대피 조치"],
    ["철골작업", "풍속 10m/s·강우량 1mm/h·강설량 1cm/h 이상 시 중지"],
    ["타워크레인 설치·수리·점검·해체", "순간풍속 10m/s 초과 시 중지"],
    ["타워크레인 운전작업", "순간풍속 15m/s 초과 시 중지"],
    ["순간풍속 30m/s 초과 후", "작업 개시 전 각 부위 이상 유무 점검"],
    ["순간풍속 35m/s 초과 우려", "건설작업용 리프트 받침·지지대 보강 등 붕괴방지 조치"],
    ["낙뢰 우려", "옥외·비계·크레인 인양·금속류 운반 등 위험 작업 중지·대피"],
  ];

  return (
    <div className="blog-wrap">
      <BlogHeader />
      <div className="blog-post-wrap">

        <div className="blog-post-header">
          <div className="blog-breadcrumb">
            <a href="/">현장통</a> › <Link to="/blog">현장가이드</Link> › <span>현장 운영</span>
          </div>
          <h1>장마철 건설현장,<br />이것만은 점검하세요 — 9대 위험과 대비</h1>
          <div className="blog-post-meta">
            <span className="meta-tag" style={{ background: "#d1fae5", color: "#065f46" }}>현장 운영</span>
            <span className="meta-tag" style={{ background: "#d1fae5", color: "#065f46" }}>현장소장·안전관리자</span>
            <span>2026.06.17</span>
            <span>읽기 5분</span>
          </div>
        </div>

        <article className="sm-article">

          <p>장마철에는 같은 작업도 더 위험해집니다. 비에 젖은 지반·발판, 습한 환경, 갑작스러운 강풍·낙뢰, 장마 후반의 무더위가 평소엔 없던 사고를 만듭니다.</p>
          <p>고용노동부와 안전보건공단은 매년 「장마철 건설현장 안전보건 길잡이」를 통해 위험요인별 사고사례·예방대책·자율점검표를 안내합니다. 이 글은 원문의 <strong>9대 위험요인</strong>을 현장에서 바로 쓸 수 있게 정리했습니다.</p>

          <h2 className="sm-h2">장마철 9대 위험요인과 핵심 대책</h2>

          <div className="fm-record-cards">
            {hazards.map((h) => (
              <div className="fm-record-card" key={h.num}>
                <div className="fm-record-header">
                  <div className="fm-record-num">{h.num}</div>
                  <div className="fm-record-title">{h.title}</div>
                </div>
                <div className="fm-record-body">
                  <p>{h.body}</p>
                </div>
              </div>
            ))}
          </div>

          <h2 className="sm-h2">기상 악화 시 작업중지 기준</h2>
          <table>
            <thead>
              <tr>
                <th>상황</th>
                <th>적용 방향</th>
              </tr>
            </thead>
            <tbody>
              {stopRules.map(([situation, action], i) => (
                <tr key={i}>
                  <td><strong>{situation}</strong></td>
                  <td>{action}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <p style={{ fontSize: "13px", color: "#94a3b8" }}>※ 구체 수치·기준은 사업장 안전보건관리계획과 관계 법령에 맞춰 확정하세요.</p>

          <div className="fm-tip-box">
            <div className="fm-tip-title">💡 핵심은 "작업 전 한 번에 점검"</div>
            <p>위험은 알고 있어도 점검을 머리로만 하면 빠집니다. 장마 시작 전 1회 전체 점검하고, 우천·강풍·폭염 예보가 뜰 때마다 아래 체크리스트로 다시 확인하세요.</p>
          </div>

          <div className="sm-cta">
            <div className="sm-cta-question">장마철 점검, 빠뜨리는 항목 없이 끝내고 싶으신가요?</div>
            <p>9대 위험요인을 한 장에 담은 <strong>장마철 안전점검 체크리스트</strong>를 무료로 드립니다.</p>
            <div className="sm-cta-buttons">
              <ChecklistDownload
                checklistTitle="장마철 건설현장 안전점검 체크리스트"
                pdf="/checklists/rainy-season-safety-checklist.pdf"
                fileName="현장통_장마철_건설현장_안전점검_체크리스트.pdf"
                className="sm-cta-btn primary"
                label="무료 체크리스트 받기 →"
              />
              <a href="/#contact" className="sm-cta-btn secondary">
                무료체험 문의하기 →
              </a>
            </div>
          </div>

          <div className="blog-tags">
            {["#장마철안전", "#건설현장안전", "#집중호우", "#토사붕괴", "#온열질환", "#밀폐공간", "#위험성평가", "#현장통", "#건설안전"].map((tag) => (
              <span key={tag}>{tag}</span>
            ))}
          </div>

          <div className="blog-related">
            <h3>다음으로 읽으면 좋은 글</h3>
            <div className="related-grid">
              <Link to="/blog/risk-assessment-5steps" className="related-card">
                <div className="related-card-tag">현장 운영</div>
                <div className="related-card-title">이번 달 위험성평가, 빠진 항목 없이 끝내는 5단계</div>
              </Link>
              <Link to="/blog/tbm-no-record" className="related-card">
                <div className="related-card-tag">현장 운영</div>
                <div className="related-card-title">TBM 매일 하는데 왜 기록이 없나 — 현장소장의 현실</div>
              </Link>
              <Link to="/blog/safety-manager-paperwork" className="related-card">
                <div className="related-card-tag">현장 운영</div>
                <div className="related-card-title">안전관리자가 서류에 치이는 진짜 이유 — 그리고 하루를 되찾는 법</div>
              </Link>
            </div>
          </div>

        </article>

        <BlogFooter />

      </div>
    </div>
  );
}

export default BlogPostRainySeason;
